import Vue from 'vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import Config from '@/config'
import constants from '@/constant'
import GoogleSlideService from '@/services/google-slide'

const noAudioTypes = new Set(constants.slideTypesNoAudio)

export default (PresentationEditorGoogleSlideComponent) => Vue.component('PresentationEditorGoogleSlideContainer', {
  data() {
    return {
      timeShowPopupInactive: Config.env === 'local' ? 1 : 3,
      joinedAt: new Date(),
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      renderPresentationDetail: (state) => state.renderPresentationDetail,
      userInactiveReload: (state) => state.userInactiveReload,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      googleSlideActiveId: (state) => state.googleSlideActiveId,
    }),
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapGetters('rightNav', ['rightNavTabNames']),
    ...mapGetters('rightPanelContainer', ['isSettingsContentVisible', 'isQuizTeamSetUpVisible']),
    isRightPanelContainerVisible() {
      if (this.isPresenting) return false
      return this.currentUser.id && !this.isBackstage && this.rightNavActiveTab
    },
    showingAudioTab() {
      return this.$store.getters.selectedSlides.some(
        (s) => s.id && !noAudioTypes.has(s.type),
      )
    },
    isSideBarBackDropVisible() {
      return this.$store.state.indicators.isHomeSideBarShowing
    },
  },
  created() {
    this.$store.state.renderPresentationDetail = false
    document.body.classList.add('remove-mobile-ui')
  },
  mounted() {
    this.setRightNavActiveTabAction(this.rightNavTabNames.CONTENT)
  },
  destroyed() {
    this.$store.state.renderPresentationDetail = false

    if (document.body.classList.contains('no-scroll-template')) {
      document.body.classList.remove('no-scroll-template')
    }
    document.body.classList.remove('remove-mobile-ui')
  },
  methods: {
    ...mapActions([
      'setPresentationAction',
      'setSlideActiveAction',
      'patchPresentationAction',
      'updateSlideActiveAction',
      'updateGoogleSlideActiveId',
    ]),
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),
    hideMenuMobile() {
      this.$store.state.indicators.isHomeSideBarShowing = false
    },
    async handleAfterLoadedPresentation() {
      const index = await GoogleSlideService.getIndexGoogleSlideActive()
      if (index !== -1 && this.presentation.slides[index].type !== 'image') {
        this.updateGoogleSlideActiveId(this.presentation.slides[index].id)
      }
    },
  },
  render(createElement) {
    // add  emit
    return createElement(PresentationEditorGoogleSlideComponent, {
      props: {
        timeShowPopupInactive: this.timeShowPopupInactive,
        joinedAt: this.joinedAt,
        showPopupUserInactive: this.showPopupUserInactive,
        isRightPanelContainerVisible: this.isRightPanelContainerVisible,
        showingAudioTab: this.showingAudioTab,
        isSideBarBackDropVisible: this.isSideBarBackDropVisible,
        hideMenuMobile: this.hideMenuMobile,
        handleAfterLoadedPresentation: this.handleAfterLoadedPresentation,
      },
    })
  },
})
